import script from "./WidgetChatPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetChatPanel.vue?vue&type=script&setup=true&lang=ts"

import "./WidgetChatPanel.vue?vue&type=style&index=0&id=f0f9465a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0f9465a"]])

export default __exports__